export const detectTDSlabIntent = (text: string) => {
    const cleaned = text.toLowerCase().trim();

    /* ----------------------------------
     * DELETE TDS SLAB (natural language)
     * ---------------------------------- */
    const deleteRegex =
        /(delete|remove|erase|drop|get rid of)\s+(the\s+)?(tds slab)?\s*(named|called|for)?\s*(.+)?/;

    const deleteMatch = cleaned.match(deleteRegex);

    if (
        deleteMatch &&
        cleaned.includes("tds") &&
        cleaned.includes("slab")
    ) {
        return {
            intent: "delete_tds_slab",
            name: deleteMatch[5]?.trim() || undefined
        };
    }

    /* ----------------------------------
     * CREATE TDS SLAB (natural language)
     * ---------------------------------- */
    const createRegex =
        /(create|add|make|setup|set up|generate)\s+(a\s+|new\s+)?(tds slab)?\s*(named|called|for)?\s*(.+)?/;

    const createMatch = cleaned.match(createRegex);

    if (
        createMatch &&
        cleaned.includes("tds") &&
        cleaned.includes("slab")
    ) {
        return {
            intent: "create_tds_slab",
            name: createMatch[5]?.trim() || undefined
        };
    }

    return null;
};
